import { createConsumer, type Consumer } from '@rails/actioncable'

// Single shared ActionCable consumer for the whole app.
// The URL is relative so Vite's dev proxy (/cable → Rails :3000) handles dev,
// and production just talks to the same origin.
let consumer: Consumer | null = null

export function cable(): Consumer {
  if (!consumer) {
    consumer = createConsumer('/cable')
  }
  return consumer
}
